import styles from "./ErrorFallback.module.css";

export default function ErrorFallback({ resetError }) {
  return (
    <div className={styles.wrap} role="alert">
      <div className={styles.card}>
        <h1 className={styles.title}>Something broke</h1>
        <p className={styles.body}>
          An unexpected error stopped the app. It has been reported. Reloading usually fixes it.
        </p>
        <button
          type="button"
          className={styles.button}
          onClick={() => {
            resetError?.();
            window.location.reload();
          }}
        >
          Reload
        </button>
      </div>
    </div>
  );
}
